export default __webpack_public_path__ + "images/0x0e899da2ad0817ed850ce68f7f489688e4d42d9d.png";